import React, { Fragment, useState, useEffect, useRef, useImperativeHandle } from 'react';
import { getProductEncodedUrl, getVariantImageUrl, parseError } from '../../../../helpers';
import Editable from '../../../common/Editable';
import Button from '../../../common/Button';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import styled from '@emotion/styled';
import { useDispatch } from 'react-redux';
import { fetchDeleteVariant, fetchEditItem } from '../../../../actions/items';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';

const EDITABLE_ROW_PROPS = [
  { prop: 'multiplicity', title: 'Кратность' },
  { prop: 'weight', title: 'Вес', tableTitle: 'Вес (кг)' },
  { prop: 'price', title: 'Цена' },
  { prop: 'article', title: 'Артикул' },
  { prop: 'barcodes', title: 'Штрихкод' },
];

const TableWrapper = styled('div')`
  margin-top: 25px;

  .variants-table {
    overflow-x: auto;
    .variant-input {
      width: 110px;
    }
    td {
      vertical-align: middle;
      &.table-item-title {
        font-weight: bold;
        cursor: pointer;
      }
      &.table-item-image {
        cursor: pointer;
      }
    }
  }
`;

const RemainingBoxesRow = (props) => {
  const { remainingQty, productShortName, variant } = props;
  return (
    <tr>
      <td style={{ width: '76px' }} className="table-item-image">
        <div
          className="image-block"
          style={{ backgroundImage: `url(${getVariantImageUrl(variant, 100)})` }}
        />
      </td>
      <td colspan="7">
        <div className="variant-id-span">
          <div> {productShortName} (штучный остаток)</div>
          <div>{variant.id}</div>
        </div>
      </td>
      <td colspan="2">{remainingQty > 0 ? remainingQty : '0'}</td>
    </tr>
  );
};

const TableRow = (props) => {
  const { item, monoboxesDictionary, updateMonoboxesDictionary, deleteMonobox, openMonoboxPage } =
    props;

  const ref = useRef(null);

  const [hoveredRow, setHoveredRow] = useState(null);
  // const [variantsValidation, setVariantsValidation] = useState(); //? Валидация editable инпутов см. getVariantsValidation

  const handleMouseLeave = () => setHoveredRow(null);

  const variantId = item.id;

  let defective = item?.stock?.reduce((a, c) => {
    a += c.stockDefective;
    return a;
  }, 0);

  return (
    <tr
      key={item.id}
      ref={ref}
      onMouseEnter={() => setHoveredRow(item.id)}
      onMouseLeave={handleMouseLeave}
    >
      {/* Image */}
      <td
        style={{ width: '76px' }}
        onClick={() => openMonoboxPage(variantId)}
        className="table-item-image"
      >
        <div
          className="image-block"
          style={{ backgroundImage: `url(${getVariantImageUrl(item, 100)})` }}
        />
      </td>

      {/* Название */}
      <td onClick={() => openMonoboxPage(variantId)} className="table-item-title">
        {item.isNew || item.unsaved ? (
          <span className="badge badge-primary mr-1">Не сохранен</span> //! Триггер сохранений - НЕ РАБОТАЕТ
        ) : null}
        {item?.title}
        <div className="variant-id-span">
          <div>{item.shortName}</div>
          <div>{item.id}</div>
          <div>{item.extId ? `(${item.extId})` : null}</div>
        </div>
      </td>

      <>
        {variantId && monoboxesDictionary[variantId]
          ? Object.keys(monoboxesDictionary[variantId]).map((key) => (
              <td key={key} style={{ width: '76px' }}>
                <Editable
                  placeholder={EDITABLE_ROW_PROPS?.find((i) => i.prop === key).title}
                  value={monoboxesDictionary[variantId][key]}
                  currentInput={hoveredRow === variantId}
                  preventFocus
                  notSaveOnEnter
                  isInvalid={
                    // variantsValidation !== true &&
                    // variantsValidation?.index === i &&
                    // variantsValidation.prop === key
                    false
                  }
                  onChange={(e) => updateMonoboxesDictionary(e.target.value, item, key)}
                />
              </td>
            ))
          : null}

        {/* Доступно */}
        <td>
          {item.stock && item.stock.length ? (
            <Fragment>
              {item.stock.reduce((a, c) => {
                a += c.stockAvailable;
                return a;
              }, 0)}
              <br />
              <Link
                to={{
                  pathname: '/orders',
                  state: {
                    reservedVariantId: item.id,
                  },
                }}
                className="variant-stock-span"
              >
                {`Резерв: ${item.stock.reduce((a, c) => {
                  a += c.stockReserved;
                  return a;
                }, 0)}`}
              </Link>

              {defective ? (
                <Fragment>
                  <Link
                    to={{
                      pathname: '/orders',
                      state: {
                        reservedVariantId: item.id,
                      },
                    }}
                    className="variant-stock-span"
                  >
                    Брак {defective}
                  </Link>
                </Fragment>
              ) : null}
            </Fragment>
          ) : null}
        </td>

        {/* Доступно, шт */}
        <td>
          <div>{item?.stockAvailable}</div>
          <div className="variant-stock-span">
            {`Резерв: ${
              item.stock.reduce((a, c) => {
                a += c.stockReserved;
                return a;
              }, 0) * item.multiplicity
            }`}
          </div>
        </td>

        <td>
          <Button
            classType="btn-link"
            type="button"
            text={<i className="fe-trash-2" style={{ color: '#6c757d', fontSize: '20px' }} />}
            onClick={() => {
              deleteMonobox(variantId);
            }}
          />
        </td>
      </>
    </tr>
  );
};

const MonoboxesTableDesktop = (props) => {
  const {
    product,
    currentMonoboxes,
    variant,
    setUnsavedStatus,
    monoboxesUpdateRef,
    refreshVariant,
  } = props;

  const dispatch = useDispatch();
  const history = useHistory();

  const { t } = useAutoTranslation();

  const [monoboxes, setMonoboxes] = useState([]);
  const [monoboxesDictionary, setMonoboxesDictionary] = useState({});
  const [availableMonoboxQty, setAvailableMonoboxQty] = useState({
    total: '',
    remaining: '',
  });
  const [shouldUpdate, setShouldUpdate] = useState(false);

  const parentPackageId = variant.id;

  useEffect(() => {
    if (currentMonoboxes.length >= 1 && product) {
      createMonoboxesDictionary(currentMonoboxes);
      handleStockAvailableData(currentMonoboxes, product);
    }
  }, [currentMonoboxes, product]);

  const handleStockAvailableData = (currentMonoboxes, product) => {
    let totalStockAvailableSum = 0;

    const updatedMonoboxes = currentMonoboxes.map((m) => {
      const stockAvailable = calculateAvailableStocksQuantity(m);
      totalStockAvailableSum += stockAvailable;

      return {
        ...m,
        stockAvailable,
      };
    });
    const totalAvailableQty = defineTotalAvailableQuantity(product);
    const remainingMonoboxesQty = totalAvailableQty - totalStockAvailableSum;

    setMonoboxes(updatedMonoboxes);
    setAvailableMonoboxQty({
      total: totalAvailableQty,
      remaining: remainingMonoboxesQty,
    });
  };

  const updateMonoboxes = async () => {
    const changeBarcode = (barcodes, value) => {
      if (barcodes && value) {
        let barcodeIndex;

        // Если ШК несколько - то отправляем на бэк default , а если такого нет - то первый по списку
        if (barcodes.length > 1) {
          barcodeIndex = barcodes.findIndex((b) => b.isDefault);
          if (barcodeIndex !== -1) {
            barcodes[barcodeIndex] = { ...barcodes[barcodeIndex], value };
          } else {
            barcodes[0] = { ...barcodes[0], value };
          }
        } else {
          barcodes[0] = { ...barcodes[0], value };
        }
      } else if (!barcodes && value) {
        barcodes = [{ value, isDefault: true }]; // Создаем первый barcode
      } else {
        barcodes = [];
      }

      return barcodes;
    };

    const variantsToUpdate = monoboxes.map((m) => {
      const updatedMonobox = monoboxesDictionary[m.id];

      if (updatedMonobox) {
        return {
          ...m,
          productId: product.id,
          variantId: m.id, //id редактируемого монокороба(варианта)
          multiplicity: parseInt(updatedMonobox.multiplicity),
          weight: parseInt(updatedMonobox.weight),
          price: parseInt(updatedMonobox.price),
          article: updatedMonobox.article,
          barcodes: changeBarcode(m.barcodes, updatedMonobox.barcodes),
        };
      } else {
        return m;
      }
    });

    product.variantsToUpdate = variantsToUpdate;

    try {
      const result = await dispatch(fetchEditItem({ product }));
      setShouldUpdate(false);
      return result;
    } catch (error) {
      toast.error(`Ошибка при обновлении монокороба ${error.data.errors[0].message}`);
    }
  };

  const deleteMonobox = async (variantId) => {
    try {
      await dispatch(fetchDeleteVariant(product.id, variantId));
      toast.info(`Монокороб [id: ${variantId}] успешно удален`);
    } catch (err) {
      toast.error(parseError(err));
    }

    await refreshVariant(product.id);
  };

  const createMonoboxesDictionary = (monoboxes) => {
    const dictionary = {};

    const defineBarcodeValue = (barcodes) => {
      if (!barcodes) return '';

      const defaultIndex = barcodes.findIndex((b) => b.isDefault);
      if (defaultIndex !== -1) {
        return barcodes[defaultIndex].value;
      } else if (defaultIndex === -1) {
        return barcodes[0].value;
      } else {
        return '';
      }
    };

    monoboxes.forEach(
      (m) =>
        (dictionary[m.id] = {
          multiplicity: m.multiplicity ? m.multiplicity : '',
          weight: m.weight ? m.weight : '',
          price: m.price ? m.price : '',
          article: m.article ? m.article : '',
          barcodes: defineBarcodeValue(m.barcodes),
          // stockAvailable: calculateAvailableStocksQuantity(m),
        }),
    );

    setMonoboxesDictionary(dictionary);
  };

  const updateMonoboxesDictionary = (value, monobox, prop) => {
    setMonoboxesDictionary({
      ...monoboxesDictionary,
      [monobox.id]: {
        ...monoboxesDictionary[monobox.id],
        [prop]: value,
      },
    });
    setShouldUpdate(true);
    setUnsavedStatus(true);
  };

  useImperativeHandle(
    monoboxesUpdateRef,
    () => {
      if (shouldUpdate) {
        return {
          updateMonoboxes,
        };
      }
      return {};
    },
    [shouldUpdate],
  );

  const openMonoboxPage = (variantId) => {
    if (!parentPackageId) {
      toast.error('Не найден parentPackageId');
      return;
    }
    const url = `/items/${product.id}/monoboxes/${variantId}`;
    history.push(url, { monoboxId: variantId, parentPackageId });
  };

  const defineTotalAvailableQuantity = (product) => {
    if (product) {
      const productVariantStock = Object.assign({}, product.variants[0].stock);
      if (productVariantStock) {
        const defaultStock = productVariantStock[0].stockTotal;
        return defaultStock || defaultStock === 0 ? defaultStock.toString() : false;
      }
    }
  };

  const calculateAvailableStocksQuantity = (monobox) => {
    const availableQty =
      monobox.stock.reduce((a, c) => {
        a += c.stockAvailable;
        return a;
      }, 0) * monobox.multiplicity;

    return availableQty;
  };

  return (
    <TableWrapper className="row">
      <div className="col-12">
        <div className="bootstrap-table">
          <div className="fixed-table-container variants-table">
            <div className="fixed-table-body">
              <table className="table table-centered">
                <thead className="thead-light">
                  <tr>
                    <th style={{ width: '76px' }}></th>
                    <th>{t('Название')}</th>
                    <Fragment>
                      {EDITABLE_ROW_PROPS.map((p) => (
                        <th>{p.tableTitle ? t(p.tableTitle) : t(p.title)}</th>
                      ))}
                    </Fragment>
                    <th>{t('Доступно')}</th>
                    <th>{t('Доступно, шт')}</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {monoboxes.map((item) => (
                    <TableRow
                      item={item}
                      monoboxes={monoboxes}
                      monoboxesDictionary={monoboxesDictionary}
                      updateMonoboxesDictionary={updateMonoboxesDictionary}
                      deleteMonobox={deleteMonobox}
                      openMonoboxPage={openMonoboxPage}
                    />
                  ))}

                  {/* Остаток штучный внизу таблицы коробов */}
                  {monoboxes.length > 0 ? (
                    <RemainingBoxesRow
                      remainingQty={availableMonoboxQty.remaining}
                      productShortName={product.shortName}
                      variant={product?.variants[0]}
                    />
                  ) : null}
                </tbody>
              </table>
            </div>
          </div>
          <p className="mt-2 mr-5" style={{ textAlign: 'end' }}>
            {availableMonoboxQty.total
              ? `${t('Всего товаров')}: ${availableMonoboxQty.total} шт.`
              : null}
          </p>
        </div>
      </div>
    </TableWrapper>
  );
};

export default MonoboxesTableDesktop;
